import { eventChannel } from 'redux-saga';
import { GAME_UPDATE, GAME_GET_STATUS } from '../constants/action-types';
import io from 'socket.io-client';
import Logger from './logger';

const sckt = class SocketService {

    constructor() { }

    register(endpoint) {

        this.socket = io(endpoint || 'http://localhost:3000').connect();
        return this.socket

    }

    async emit(data) {

        return await new Promise((resolve, reject) => {

            this.socket.emit(data, (res) => {

                resolve(res)

            })

        })

    }

}


export default new sckt()


// WEBPACK FOOTER //
// ./src/services/socket.js